/**
 * Initialise handlers used across any display item based components
 */

import React from 'react';

import * as Dom from '../utils/domUtils';

import { queryStringObject } from '../utils/browser';

import SharingInterface from '../../apps/common/Sharing/index.js';

// Enums.
import { AnalyticsEvents as PUB } from '../../common/config/api';

export function initOverlayHandler(e) {
  if (e.type !== 'click' && e.which !== 13) return;
  e.preventDefault();
  e.stopPropagation();
  var $item = $(this),
    $asset = $item.find('.xActionOverlay'),
    $component = $item.parents('.xComponent'),
    theComponent = NGX.App.Components.get($component.attr('id')),
    content = null,
    contentSource = $item.data('ngxOverlaysource');

  switch (contentSource) {
    case 'json':
      // If the item comes from JSON embedded in the page, use that (i.e. video module)
      content = window[$component.attr('id')][$item.data('ngxOverlaycontent')] || {};
      content.itemOpts = theComponent.get('itemOpts');

      if ($asset.data('ngxSourceid')) {
        content.extId = $asset.data('ngxSourceid');
        content.network = $asset.data('ngxService');
      }
      // Trigger the overlay directly
      Dom.popOverlayFromJSON(content);
      break;

    case 'ajax':
      // Call overlay method with item's ID
      Dom.popOverlayForDisplayItem($item.data('ngxId'), theComponent);
      break;

    case 'external':
      break;

    default:
      // Fall back to getting the item's markup directly
      NGX.overlay.create({
        content: $item.html(),
        event:   e.originalEvent,
      });
      break;
  }
}

// For use in social walls where details strategy is to go directly to the network
export function initExternalLinkHandler(e) {
  const targ = e.target,
    parent = targ.parentElement;

  if (!$(targ).hasClass('xContentLink')) {
    e.preventDefault();
    e.stopPropagation();
    var externalLink = this.getAttribute('data-ngx-sourcelink'),
      linkTarget = this.getAttribute('data-ngx-sourcetarget');

    // Support for some items having two CTA's
    if (parent.tagName === 'A') {
      externalLink = parent.getAttribute('href');
      linkTarget = parent.getAttribute('target');
    }

    // API
    var id = this.getAttribute('data-ngx-id');
    NGX.Analytics.trigger('action:cta', {
      moduleId: id,
      url:      externalLink,
    });

    // Track the view
    if (id) {
      NGX.Insights.track('click:contentitem', { i: id, link: externalLink });
    }

    // Respect module's target setting
    if (linkTarget === '_blank') {
      var childWindow = window.open(externalLink);
      childWindow.opener = null;
    } else {
      document.location = externalLink;
    }
  }
}

// For use in image gallery with medialayer items to avoid wrapping in <a/> tag
export function initInternalLinkHandler(e) {
  const targ = e.target,
    parent = targ.parentElement;

  if (!$(targ).hasClass('xContentLink')) {
    e.preventDefault();
    e.stopPropagation();
    var internalLink = this.getAttribute('data-ngx-sourcelink'),
      linkTarget = this.getAttribute('data-ngx-sourcetarget');

    // Support for some items having two CTA's
    if (parent.tagName === 'A') {
      internalLink = parent.getAttribute('href');
      linkTarget = parent.getAttribute('target');
    }

    // Integration API
    var moduleId = this.getAttribute('data-ngx-id');
    NGX.Analytics.trigger('action:cta', {
      moduleId: moduleId,
      url:      internalLink,
    });

    NGX.App.api.action(internalLink, {
      link:      '#',
      ctatarget: linkTarget,
    });
  }
}

// For use in image gallery where medialayer is linked with cta link
// not wrapping in <a> tag to maintain existing markup
export function initLinkHandler(e) {
  var targ = e.target;
  var parent = targ.parentElement;
  var sourceLink = this.getAttribute('data-ngx-sourcelink');

  // check for internal(page) or external link, and if target is item rather than cta button
  if (/route:/.test(sourceLink) && parent.classList.contains('xMedialayer')) {
    initInternalLinkHandler.bind(this)(e);
  } else if (parent.classList.contains('xMedialayer')) {
    initExternalLinkHandler.bind(this)(e);
  }
}

// Used to trigger an API action on the CTA being clicked
export function initCTALink(e) {
  // Walk the tree until we find our module id
  var parent = e.currentTarget.parentElement;
  while (!parent.dataset.ngxId && parent !== document.body) {
    parent = parent.parentElement;
  }

  if (e.currentTarget.dataset.ngxAction) {
    if (e.currentTarget.dataset.ngxAction.startsWith('share:campaign:')) {
      // Do not trigger an action:cta when the CTA is being used to share the campaign
      return;
    }
  }

  const internal = e.currentTarget.href.startsWith(window.location);

  NGX.Analytics.trigger('action:cta', {
    moduleId: parent.dataset.ngxId,
    url:      e.currentTarget.href,
  });
}

// Handle shoppable social wall links
export function initCTALinkHandler(e) {
  e.preventDefault();
  e.stopPropagation();
  var $parentEl = $(this).parents('.hasCTA'),
    externalLink = $parentEl.attr('data-ngx-ctalink'),
    linkTarget = $parentEl.attr('data-ngx-ctatarget'),
    linkAction = $(this).attr('data-ngx-action');

  // API
  var moduleId = this.getAttribute('data-ngx-id');
  NGX.Analytics.trigger('action:cta', {
    moduleId: moduleId,
    url:      externalLink,
  });

  NGX.App.api.action(linkAction, {
    link:      externalLink,
    ctatarget: linkTarget,
  });
}

// Handle network actions (Twitter's retweet/reply etc)
const initNetworkActionHandler = function(e) {
  e.preventDefault();
  e.stopPropagation();
  const theAction = $(this).attr('data-ngx-action');
  if (theAction) NGX.Util.action(theAction);
};

const initPromoDetailsHandler = function(e) {
  e.preventDefault();
  e.stopPropagation();

  const promo = this;
  let theAction;
  const ctxt = NGX.Dom.getAttrsByPrefix(promo, 'data-ngx-');
  if (ctxt.action) {
    theAction = ctxt.action;
  } else if (ctxt.details == 'inline' || ctxt.details == 'detail') {
    theAction = 'display:promo:' + ctxt.id;
  }
  if (theAction) NGX.Util.action(theAction, ctxt);
};

// Create modal with icons for multiple sharing icons
const initShareModal = function(e) {
  // Shows the multi network sharing modal
  e.stopPropagation();
  e.preventDefault();
  var $item = $(this).parents('.xItem'),
    cmp = NGX.App.Components.get(
      $(this)
        .parents('.xComponent')
        .attr('id')
    ),
    itemObj = null;

  $.getJSON('/display/api/content/displayItem/' + $item.data('ngxId') + '.json')
    .success(function(response) {
      if (response.count == 1) {
        itemObj = _.extend({}, response.content[0], { itemOpts: cmp.get('itemOpts'), title: 'Share' });
      }
    })
    .done(function() {
      if (itemObj) {
        // Define config for sharing component.
        const sharingConfig = {
          mode:   itemObj.itemOpts.sharingMode,
          style:  itemObj.itemOpts.sharingStyle,
          render: 'mode.overlay.content',
        };

        // Define React Sharing component.
        const sharing = (
          <SharingInterface.Components.Sharing
            item={itemObj}
            config={sharingConfig}
            keys={itemObj.itemOpts.sharingKeys}
            actions={itemObj.actions.sharing}
          />
        );

        // Create React Overlay.
        Dom.createReactOverlay(sharing, 'xOverlay-shareModal');
      }
    });
};

const initSocialWallShowMore = function(e) {
  var $btn = $(this),
    $btnInner = $('span', $btn),
    $cmp = $(e.currentTarget).parents('.xComponent'),
    cmp = NGX.App.Components.get($cmp.attr('id')),
    $cInner = $('.xContainerInner', $cmp),
    btnText = $btnInner.text(); // Cache this for later replacing

  $cInner.css({ minHeight: $cInner.outerHeight(true) });

  var moduleOpts = cmp.get('moduleOpts'),
    templateOpts = cmp.get('templateOpts');

  var pageSize = cmp.get('pageSize'),
    offset = cmp.get('offset');

  // Set button's text to "Loading..." to prevent delayed ajax looking like it's stalled
  $btnInner.text(NGX.lang.get('loading'));

  // Build the params object for sending off to the controller
  var _contentParams = {
    apikey:       NGX.context.apikey,
    cID:          NGX.App.config.id || 0,
    moduleDomID:  cmp.get('moduleDomID'),
    pageSize:     pageSize,
    offset:       offset,
    moduleOpts:   JSON.stringify(moduleOpts),
    templateOpts: JSON.stringify(templateOpts),
  };

  $.ajax({
    url:      '/display/content/contentItems',
    data:     _contentParams,
    dataType: 'html',
  }).success(function(response) {
    // Hide button if we've come to the end of the list
    if (offset + pageSize >= cmp.get('total')) $btn.addClass('xHidden');
    $cInner.append(response);
    $cInner.imagesLoaded(function() {
      // Resize the social wall for new items and re-trigger packery
      $cInner.css({ minHeight: '' });
      if (typeof $cInner.data('packery') !== 'undefined') {
        $cInner.packery('reloadItems').packery('layout');
      }
      NGX.App.Events.trigger('content:added');
      // Resize the parent
      setTimeout(function() {
        NGX.App.api.resizeParent();
      }, 1000);
      // Reset the button text
      $btnInner.text(btnText);
    });
  });

  cmp.set('offset', offset + pageSize);
};

export function applyClickHandlers() {
  'use strict';

  log.debug('Initialising Display Item Click Handlers', 2);

  $('xComponent').unbind();

  // Bind API triggers to CTA links in a Callout
  $('[data-componenttype="callout"]').on('click', 'a', initCTALink);

  // Do not apply Global click handlers if using new UGGWalls.
  if (!NGX.App.config.useNewUGCWalls) {
    // Apply click handlers to all components
    $('.xComponent')
      .on('click', '.xContainer .xTriggerOverlay', initOverlayHandler)
      .on('click', '.xContainer .xTriggerExternal', initExternalLinkHandler)
      .on('click', '.xCTACopyContainer .xCTA', initCTALinkHandler)
      .on('click', '.xActionNetwork a', initNetworkActionHandler)
      .on('click', '.xShareModal', initShareModal);

    // Add pagination handler to social walls
    $('.xComponent.xSocialContentWall').on('click', '.xActionShowMore', initSocialWallShowMore);
  } else {
    // Disabling global click handlers prevents non-socialwall handlers too, specifically apply video overlay handler here
    $('.xComponent').on(
      'click',
      '.xContainerVideo .xTriggerOverlay, .xContainerVideoGallery .xTriggerOverlay, .xContainerSocialContentCarousel .xTriggerOverlay',
      initOverlayHandler
    );

    // Apply external click handlers.
    $('.xComponent').on('click', '.xContainer.xClassCarousel .xTriggerExternal', initExternalLinkHandler);

    // Apply image gallery medialayer link handler
    $('.xComponent').on('click', '.xContainer .xClassGallery.xMedialayer[data-ngx-sourcelink]', initLinkHandler);

    // For accessibility we need videos to be responsive to the return key
    $('.xComponent').on(
      'keydown',
      '.xContainerVideo .xTriggerOverlay, .xContainerVideoGallery .xTriggerOverlay, .xContainerSocialContentCarousel .xTriggerOverlay',
      initOverlayHandler
    );
  }

  // Remove existing promotion event handlers, so that they are not re-registered multiple times.
  $('.xComponent')
    .off('click', '[data-ngx-details=detail],[data-ngx-details=inline]')
    .off('click', '[data-ngx-details=click]');

  // Register event handlers to setup promotion clicks.
  $('.xComponent')
    .on('click', '[data-ngx-details=detail],[data-ngx-details=inline]', initPromoDetailsHandler)
    .on('click', '[data-ngx-details=click]', initExternalLinkHandler);
}

export default (function() {
  return {
    applyClickHandlers,

    init: function() {
      applyClickHandlers();

      // Generate Insight Events using out form events. This is a bit of a cheat, and we
      // might want to look at moving this to the Insights.js module.
      //
      // UNCOMMENT TO ENABLE
      //
      //NGX.Analytics.on(PUB.ACTION_CTA, function (params) {
      //  NGX.Analytics.trigger(PUB.INSIGHT_CLICKTHROUGH, params);
      //});

      NGX.App.Events.on('page:ready', function() {
        // Function called after the item ID or promo ID values have been retrieved.
        var showItem = function(theID, promoID) {
          // If we have a promo ID.
          if (promoID) {
            log.debug('There\'s a promo ID available, attempting to load it', 5);

            var ctxt = {};

            // Attempt to locate a matching promotion element.
            var promoEl = $('#xPromo' + promoID);

            // If matching promotion element was found.
            if (promoEl.length) {
              ctxt = NGX.Dom.getAttrsByPrefix(promoEl[0], 'data-ngx-');

              // If the promotion has some details to show.
              if (ctxt.details && (ctxt.details === 'inline' || ctxt.details === 'detail')) {
                NGX.App.api.action('display:promo:' + promoID, ctxt);

                // Otherwise, just attempt to scroll to it.
              } else {
                NGX.App.api.scrollTo(0, promoEl.position().top);
              }

              // If no matching promotion elements was found (ie, this promoID has been accessed via a different campaign) then just use detaults.
            } else {
              NGX.App.api.action('display:promo:' + promoID);
            }

            // If we have an item ID
          } else if (theID) {
            log.debug('There\'s an item ID available, attempting to load it', 5);
            Dom.popOverlayForDisplayItem(theID);
          }
        };

        // Get ID defaults.
        var theID = queryStringObject('ngxItemID') || null;
        var promoID = queryStringObject('ngxPromoID') || null;

        // Check if itemID exists in appData.
        if (!theID && NGX.context.appData) {
          var appData = JSON.parse(NGX.context.appData);
          if (!isNaN(appData.ngxItemID)) theID = appData.ngxItemID;
        }

        // If we are inside a frame, check if either ngxItemID or ngxPromoID override value is present on the parent URL.
        if (NGX.App.state.framed) {
          NGX.Browser.getParentParams(function(params) {
            theID = params.ngxItemID ? params.ngxItemID : theID;
            promoID = params.ngxPromoID ? params.ngxPromoID : promoID;

            showItem(theID, promoID);
          });

          // If not framed, then execute immediately using the values we have.
        } else {
          showItem(theID, promoID);
        }
      });
    },
  };
})();
